import React from 'react'
import { ThemeContext } from 'styles/theme-provider'
import { LocaleContext } from 'styles/locale-provider'

import Button from 'components/ui-elements/button'
import FadeOutSection from '../ui-elements/fade-out-section'
import FadeLeftSection from '../ui-elements/fade-left-section'
import BookSection from '../book-section'
import ContactForm from '../contact-form'
import Menu from './menu'
import SelectLanguage from '../ui-elements/select-language'
import SubmenuList from '../ui-elements/submenu-list'
import LegalMenu from '../ui-elements/legal-menu'
import {
  Wrapper,
  Logo,
  LogoMini,
  Links,
  Li,
  LinkItem,
  ContactLink,
} from './index.styled'

const Header = ({ location, isHome }) => {
  const { siteTheme, setResetForm, scrollSmoother } = React.useContext(
    ThemeContext,
  )
  const { getI18Url, localeText } = React.useContext(LocaleContext)

  const [openBook, setOpenBook] = React.useState(false)
  const [openContact, setOpenContact] = React.useState(false)
  const [openMenu, setOpenMenu] = React.useState(false)
  const [openContactMob, setOpenContactMob] = React.useState(false)

  const [isHide, setIsHide] = React.useState(true)

  const onContactClick = () => {
    setOpenContact(!openContact)
    setOpenBook(false)
    setResetForm(true)
  }
  const onContactMobClick = () => {
    setOpenContactMob(true)
    setOpenBook(false)
    setResetForm(true)
  }

  const onBookClick = () => {
    setOpenBook(!openBook)
    setOpenContact(false)
    setOpenContactMob(false)
    setOpenMenu(false)
  }

  const onMenuClick = () => {
    setOpenBook(false)
    setOpenContact(false)
    setOpenContactMob(false)

    // setOpenMenu(!openMenu)

    openContactMob
      ? setTimeout(() => setOpenMenu(!openMenu), 1000)
      : setOpenMenu(!openMenu)
  }

  React.useEffect(() => {
    if (openMenu || openBook || openContact) {
      scrollSmoother.current.paused(true)
    } else {
      setTimeout(() => scrollSmoother.current.paused(false), 1000)
    }
  }, [openBook, openContact, openMenu])

  React.useEffect(() => {
    setOpenBook(false)
    setOpenContact(false)
  }, [location.pathname])

  React.useEffect(() => {
    setTimeout(() => setIsHide(false), 100)
  }, [])

  return (
    <>
      <Wrapper
        id="header"
        className={[
          isHide ? 'hide' : '',
          siteTheme,
          openBook && 'opened book',
          openContact && 'opened',
          openMenu && 'opened menu',
          openContactMob && 'contact',

          isHome && 'home',
        ].join(' ')}
      >
        <Menu
          open={openMenu}
          onClose={onMenuClick}
          onContactMob={onContactMobClick}
        />
        <FadeOutSection open={openBook}>
          <BookSection />
        </FadeOutSection>
        <FadeOutSection open={openContact}>
          <ContactForm />
        </FadeOutSection>
        <FadeLeftSection open={openContactMob}>
          <ContactForm onBackMobClick={() => setOpenContactMob(false)} />
        </FadeLeftSection>
        <div>
          <LogoMini to={getI18Url('/')} alt="Kanai logo" />
          <Logo to={getI18Url('/')} alt="Kanai logo" />
        </div>
        <SubmenuList />
        {location.pathname === getI18Url('/legal/') && <LegalMenu />}

        <Links>
          <Li className={'select-lang'}>
            <SelectLanguage />
          </Li>
          {/* <Li>
            <LinkItem to={getI18Url('/press')}>{localeText['press']}</LinkItem>
          </Li> */}
          <Li className="li-contact">
            <ContactLink onClick={onContactClick} type="button">
              <span className={openContact && 'hide'}>
                {localeText.contact}
              </span>
              <span className={!openContact && 'hide'}>{localeText.close}</span>
            </ContactLink>
          </Li>
          <Li>
            <Button
              $inverted={
                siteTheme === 'header-white' || siteTheme === 'header-black'
              }
              as="button"
              type="button"
              onClick={onBookClick}
              bkey="book"
              textOpen={localeText.close}
            >
              {localeText['book.button']}
            </Button>
          </Li>
          <Li>
            <Button
              className={[
                siteTheme === 'header-white' || siteTheme === 'header-black'
                  ? 'light-green'
                  : 'lightBlue-green',
              ].join(' ')}
              as="button"
              type="button"
              bkey="menu"
              onClick={onMenuClick}
              textOpen={localeText.close}
            >
              {localeText.menu}
            </Button>
          </Li>
        </Links>
      </Wrapper>
    </>
  )
}

export default Header
